"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timer = void 0;

var _react = _interopRequireDefault(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _time = require("../../../../helpers/time");

var _timer = require("../../actions/timer");

var _reactRedux = require("react-redux");

var _timer2 = require("../../selectors/timer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimerWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimerWrapper, _React$Component);

  function TimerWrapper(props) {
    var _this;

    _classCallCheck(this, TimerWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimerWrapper).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "localTimerId", void 0);

    _defineProperty(_assertThisInitialized(_this), "checkTime", void 0);

    _defineProperty(_assertThisInitialized(_this), "lastUpdate", void 0);

    _defineProperty(_assertThisInitialized(_this), "memoizedCheckTimer", (0, _memoizeOne["default"])(_this.checkTimer));

    _this.localTimerId = null;
    _this.checkTime = null;
    _this.lastUpdate = 0;
    return _this;
  }

  _createClass(TimerWrapper, [{
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;

      if (!this.localTimerId) {
        this.checkTime = Date.now();
        this.localTimerId = setInterval(function () {
          var _this2$props = _this2.props,
              setTimer = _this2$props.setTimer,
              onEnd = _this2$props.onEnd,
              localTimer = _this2$props.localTimer,
              stageId = _this2$props.stageId;

          if (onEnd && (0 === localTimer - 1 || 0 === localTimer)) {
            onEnd();
            _this2.lastUpdate = 0;

            _this2.stopTimer();
          }

          _this2.lastUpdate += 1000;
          setTimer(localTimer - 1, stageId);
        }, 1000);
      }
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      if (this.localTimerId) {
        clearInterval(this.localTimerId);
        this.localTimerId = null;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (null === this.props.localTimer || undefined === this.props.localTimer) {
        this.props.setTimer(this.props.currentTimer, this.props.stageId);
      }
    }
  }, {
    key: "checkTimer",
    value: function checkTimer(canTick) {
      if (canTick) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          currentTimer = _this$props.currentTimer,
          updateTimer = _this$props.updateTimer,
          setTimer = _this$props.setTimer,
          stageId = _this$props.stageId,
          forceSync = _this$props.needSync;
      var latency = 5000;
      var needSync = Math.abs(Date.now() - this.checkTime - this.lastUpdate) > latency || !updateTimer;

      if (prevProps.currentTimer !== currentTimer || forceSync) {
        this.lastUpdate = 0;
        this.checkTime = Date.now();
        setTimer(currentTimer, stageId);
      } else if (needSync && updateTimer) {
        updateTimer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          canTick = _this$props2.canTick,
          defaultTimer = _this$props2.defaultTimer,
          localTimer = _this$props2.localTimer,
          format = _this$props2.format,
          _this$props2$isNegati = _this$props2.isNegativeValues,
          isNegativeValues = _this$props2$isNegati === void 0 ? true : _this$props2$isNegati,
          _this$props2$withLabe = _this$props2.withLabels,
          withLabels = _this$props2$withLabe === void 0 ? false : _this$props2$withLabe;
      this.memoizedCheckTimer(canTick);

      if (!isNegativeValues && 0 > localTimer) {
        this.stopTimer();
      } else if (!this.localTimerId && canTick) {
        this.startTimer();
      }

      if (withLabels) {
        return (0, _time.formatSecondsToLabel)(canTick ? localTimer : defaultTimer, format);
      }

      return (0, _time.formatSeconds)(canTick ? localTimer : defaultTimer, format);
    }
  }]);

  return TimerWrapper;
}(_react["default"].Component);

_defineProperty(TimerWrapper, "defaultProps", {
  autoUpdate: true,
  canTick: true,
  needSync: false
});

function mapStateToProps(state, props) {
  return {
    localTimer: (0, _timer2.selectTimer)(state, props.stageId)
  };
}

var Timer = (0, _reactRedux.connect)(mapStateToProps, {
  setTimer: _timer.setTimer
})(TimerWrapper);
exports.Timer = Timer;